module.exports = __webpack_public_path__ + "img/gx.408622d0.jpg";